import { DatePipe } from '@angular/common';
import { Component, Injector, OnInit } from '@angular/core';
import { forkJoin } from 'rxjs';
import { BaseComponent } from '../base/base.component';
import { PublicationService } from '../services/publication/publication.service';
import { PublishingListItem } from '../services/publishing/PagedPublishingList';
import { PublishingService } from '../services/publishing/publishing.service';
import { PublicationModel } from '../shared/model/publication.model';
import { EMonitorMessageService } from '../services/e-monitor-message/e-monitor-message.service';
import { eMonitorMessageModel } from '../shared/model/eMonitor-message.model';
import { ActivatedRoute, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-projects',
  templateUrl: './projects.component.html',
  styleUrls: ['./projects.component.css']
})
export class ProjectsComponent extends BaseComponent implements OnInit {
  publicationYears: string[] = [];
  publicationService: PublicationService;
  private publishingService: PublishingService;
  publications: PublishingListItem[] = [];
  publicationYear: string;
  publicationSelected: PublishingListItem;
  publication: PublicationModel;
  publicationLabel: string;
  private datePipe: DatePipe;
  inputPublishingId: string;
  public UserName: string;
  eMonitorMessageService: EMonitorMessageService;
  announcement = new eMonitorMessageModel("", "");
  url = "";


  constructor(public _injector: Injector, private route: ActivatedRoute) {
    super(_injector);
    this.publicationService = this._injector.get(PublicationService);
    this.publishingService = this._injector.get(PublishingService);
    this.datePipe = this._injector.get(DatePipe);
    this.eMonitorMessageService = this._injector.get(EMonitorMessageService);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.publicationYears = ['Year'];
    forkJoin([this.publicationService.getPublicationYears(), this.publishingService.GetLatestPublication(),
    this.eMonitorMessageService.GetMessage("GeneralMessage")])
      .subscribe(([years, publishingListItem, generalAnnouncement]) => {

        let pDate = this.publicationService.getPublicationDate();
        let pYear = this.publicationService.getPublicationYear();

        if (pYear != undefined)
          this.publicationYear = pYear;

        if (pDate != undefined)
          this.publicationSelected = pDate;


        if (years != null && years.length > 0) {
          this.publicationYears = this.publicationYears.concat(years.map(String));;
        }

        this.SetPublicationYearIfExistent(publishingListItem, pDate, pYear);
        this.announcement = generalAnnouncement;
      });
    this.ListenToRouter();
  }

  private SetPublicationYearIfExistent(publishingListItem: PublishingListItem, pDate: PublishingListItem, pYear: string) {
    if (this.PublicationExistentAndNoYearOrDate(publishingListItem, pDate, pYear)) {
      this.publicationYear = publishingListItem.year;
      this.setPublicationYear(this.publicationYear, publishingListItem);
    }
    else {
      this.setPublicationYear(pYear, pDate);
      this.GetPublication();
    }
  }

  private PublicationExistentAndNoYearOrDate(publishingListItem: PublishingListItem, pDate: PublishingListItem, pYear: string) {
    return publishingListItem != null && (pDate == undefined || pYear == undefined);
  }

  setPublicationYear(year: any, publishing: PublishingListItem = null) {
    this.showProgress();
    this.publishingService.GetPublications(year).subscribe((publicationList: PublishingListItem[]) => {
      this.publications = [new PublishingListItem];

      this.publicationSelected = this.publications[0];

      if (this.PublicationListNotNullOrEmpty(publicationList)) {
        this.publications = this.publications.concat(publicationList);
      }
      if (publishing != null) {
        this.publicationSelected = this.publications.find(pub => pub.publishingId == publishing.publishingId);
        this.GetPublication();
      }
      this.hideProgress();
    });
  }

  private PublicationListNotNullOrEmpty(publicationList: PublishingListItem[]) {
    return publicationList !== null && publicationList.length !== 0;
  }

  GetPublication() {
    this.showProgress();
    this.publicationService.getPublication(this.publicationSelected.publishingId).subscribe(publication => {
      this.publication = publication;
      var transformDate = this.publication.publishDate != undefined ? this.datePipe.transform(this.publication.publishDate, 'MMM d, y') : '';
      this.publicationLabel = 'Publication: ' + transformDate +
        ' | Volume ' + this.publication.volumeNumber +
        ' | Issue ' + this.publication.issueNumber;
      this.inputPublishingId = this.publicationSelected.publishingId;
      this.publicationService.setPublicationDate(this.publicationSelected);
      this.publicationService.setPublicationYear(this.publicationYear);
      this.hideProgress();
    }, error => {
      this.hideProgress();
    });
  }

  private ListenToRouter() {
    this.router.events.subscribe((e) => {
      if (e instanceof NavigationEnd && window.location.href.indexOf("home") > 1) {
        this.url = window.location.protocol + '//' + window.location.hostname + '//' + window.location.pathname;// window.location.href.replace(window.location.hash, "");
      }
    });
  }

  onAnchorClick ( ) {
    this.route.fragment.subscribe ( f => {
      const element = document.querySelector ( "#" + f )
      if ( element ) element.scrollIntoView ()
    });
  }
}
